export default __webpack_public_path__ + "static/sdg-3-0a4ae9268802a5c226cee83d31acd534.png";